import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";
import {CheckedBox} from "@rw/icons";

import {IStore} from "../../../app/reducers/hybrid_reducer";
import {CategoriesENEnum, categoriesPL, getOptionsByCategory, Option} from "../../../dashboard/add_car/options/multimedia_options";
import {MultimediaOptions} from "../actions/fetch_cars_details_at_route";

const OptionItem = ({label}: {label: string}) => {
    const theme = useTheme();
    return (
        <li css={optionListItem}>
            <span css={optionItemElement}>
                <CheckedBox mainColor={theme.colors.brand_primary} />
                {label}
            </span>
        </li>
    );
};

interface IOptionListProps {
    category: string;
    selectedOptions: string[];
    options: Option[] | undefined;
    isFirst: boolean;
}

const OptionList = ({category, selectedOptions, options, isFirst}: IOptionListProps) => {
    const [isOpen, setIsOpen] = useState(isFirst);
    const [selectedState, setSelectedState] = useState<Option[]>([]);
    const theme = useTheme();

    useEffect(() => {
        const filteredOptions = options?.filter((option: any) => selectedOptions.includes(option.value));
        setSelectedState(filteredOptions || []);
    }, [selectedOptions, options]);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div css={optionList}>
            <div css={accordionHeader(isOpen, theme)} onClick={toggleAccordion}>
                <h5>{category}</h5>
            </div>
            {isOpen && <ul css={optionItem}>{selectedState?.map((option: Option) => <OptionItem key={option.value} label={option.label} />)}</ul>}
        </div>
    );
};

export const CarDetailsOptionList = () => {
    const multimedia_options = useSelector((store: IStore) => store.offer.car.data.multimedia_options);
    if (!multimedia_options) {
        return null; // Zwracaj null zamiast niczego
    }

    const nonEmptyOptions = Object.keys(multimedia_options).reduce((acc, key) => {
        const typedKey = key as keyof MultimediaOptions;
        const value = multimedia_options[typedKey];
        if (value.length > 0) {
            acc[typedKey] = value;
        }
        return acc;
    }, {} as Partial<MultimediaOptions>);

    return (
        <>
            {categoriesPL
                .filter((category) => {
                    const categoryOptions = nonEmptyOptions[category.value as CategoriesENEnum];
                    return categoryOptions && categoryOptions.length > 0;
                })
                .map((category, index) => (
                    <div key={category.value} className="car-options">
                        <OptionList
                            isFirst={index === 0}
                            category={category.label}
                            selectedOptions={nonEmptyOptions[category.value as CategoriesENEnum] || []}
                            options={getOptionsByCategory(category.value)}
                        />
                    </div>
                ))}
        </>
    );
};

const optionListItem = css`
    list-style: none;
    margin-bottom: 0.6rem;
`;

const optionItemElement = css`
    display: flex;
    align-items: center;
    svg {
        display: inline;
        margin: 0 0.6rem;
    }
`;

const accordionHeader = (open: boolean, theme: Theme) => css`
    border-bottom: 2px solid ${theme.colors.brand_primary};
    background-color: ${open ? theme.colors.brand_primary : "transparent"};
    color: ${open ? "#fff" : theme.colors.text_color};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 2rem;
`;

const optionList = css`
    list-style-type: none;
    padding: 10px 10px 10px 0;
    margin: 0;
    max-width: 400px;
`;

const optionItem = css`
    //padding: 0.5rem 0 0.5rem 3.5rem;
    padding: 0;
    border-bottom: 1px solid #ddd;
    &:last-child {
        border-bottom: none;
    }
`;
